export { default as Data, type DataProps } from './Data';
export { default as useData } from './useData';
